exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Add any specific styles for the SVG container if needed */\ndiv[data-v-10df70ca] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
